"use client";

import Image from "next/image";
import { useState } from "react";

const navLinks = [
  { href: "#hero", label: "Home" },
  { href: "#safety", label: "Safety" },
  { href: "#medical", label: "Medical" },
  { href: "#family", label: "Family Zone" },
  { href: "#panicsa", label: "PanicSA" },
  { href: "#crowd", label: "Crowd Flow" },
  { href: "#team", label: "Our Team" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-springbok-dark/95 backdrop-blur-sm border-b border-springbok-green/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <a href="#hero" className="flex items-center gap-3">
            <Image
              src="/Images/Fanpark.png"
              alt="Bomb Squad Fan Park Logo"
              width={44}
              height={44}
              className="rounded-full bg-white p-0.5"
            />
            <span className="text-white font-bold text-lg hidden sm:block">
              Bomb Squad <span className="text-springbok-gold">Fan Park</span>
            </span>
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-neutral-200 hover:text-springbok-gold px-3 py-2 text-sm font-medium transition-colors rounded-md hover:bg-white/5"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Mobile toggle */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {open ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-springbok-dark border-t border-springbok-green/30">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="block text-neutral-200 hover:text-springbok-gold px-3 py-2 text-sm font-medium transition-colors rounded-md hover:bg-white/5"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
